import { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import Select from "react-select";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProvider, uploadWalletProvider } from "../../../config/LiveApi";

const UploadBalance = ({ onClose, onSuccess }) => {
  const token = useSelector((store) => store.userReducer.token);

  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [uploadAmount, setUploadAmount] = useState("");

  const fetchProviders = async () => {
    setLoading(true);
    try {
      const response = await getProvider(token);
     const filteredProviders = (response.data?.providers || []).filter(
  (p) =>
    (p.type === "payout" || p.type === "both") &&
    p.mode !== "UPI"
);


      setProviders(filteredProviders);
    } catch (err) {
      toast.error("Failed to fetch providers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchProviders();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedProvider) {
      toast.error("Please select a provider");
      return;
    }

    if (!uploadAmount || Number(uploadAmount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    const payload = {
      providerId: selectedProvider.value,
      uploadAmount: uploadAmount.toString(), 
    };

    setLoading(true);
    try {
      await uploadWalletProvider(token, payload);
      toast.success("Balance uploaded successfully");
      onClose();
      onSuccess?.();
    } catch (err) {
      toast.error("Failed to upload balance");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Provider Name - Org Name
  const providerOptions = providers.map((p) => ({
    value: p.id,
    label: `${p.providerName} - ${p.orgName}`,
  }));

  return (
    <div className="ips-modal-overlay">
      <div className="ips-modal-content">
        <button onClick={onClose} className="ips-modal-buttons-close">
          <FaTimes size={25} />
        </button>

        <h2>Upload Balance</h2>

        <form onSubmit={handleSubmit}>
          <label>Select Provider:</label>
          <Select
            options={providerOptions}
            value={selectedProvider}
            onChange={setSelectedProvider}
            isLoading={loading}
            placeholder="Provider Name - Org Name"
          />

          <label>Amount:</label>
          <input
            type="number"
            placeholder="Enter Amount"
            value={uploadAmount}
            onChange={(e) => setUploadAmount(e.target.value)}
          />

          <button
            className="ips-modal-buttons"
            type="submit"
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadBalance;
